import { Reducer } from 'redux';
import { IWPContentState } from './type';
import { TypesWPContent } from 'redux/actions/WPContent/type';

const WPContentState: IWPContentState = {
  header: {
    menu: [],
    log_in: '',
    contacts: {
      phone: {
        target: '',
        title: '',
        url: '',
      },
      email: '',
      schedule: '',
    },
  },
  footer: {
    address: '',
    contacts: '',
    license: '',
    logo: {
      url: '',
      height: '',
      width: '',
    },
    menu: [],
    app: {
      active: false,
      image: '',
      title: '',
      links: [],
    },
    socials: {
      title: '',
      list: [],
    },
  },
  isLoaded: false,
  isLoading: false,
  isFailed: false,
  openModal: null,
};

// const WPContentState: IWPContentState = {
//   header: {
//     menu: [
//       {
//         title: 'Our advantages',
//         url: '#advantages',
//       },
//       {
//         title: 'How to borrow',
//         url: '#steps',
//       },
//       {
//         title: 'Customer reviews',
//         url: '#testimonials',
//       },
//     ],
//     mobile_menu_title: 'Reference Information',
//     contacts: {
//       phone: '+91 951 331 08 14',
//       phone_text: 'Monday-Friday: 8:30 am - 5:30 pm',
//     },
//   },
//   footer: {
//     contacts: {
//       phone_title: 'Support service',
//       phone: '+91 9513310814',
//       phone_text: 'Mon-Fri: 8.30AM to 5.30PM',
//       email_title: 'Mail Addresses',
//       email: 'info@lendplus.in',
//       schedule_title: 'Schedule',
//       schedule: 'Mon-Fri: 8.30AM to 5.30PM',
//     },
//     socials: [
//       {
//         icon: 'https://wp-kenya-react.cashplus-ke.avgr.it/wp-content/uploads/2021/12/facebook.svg',
//         url: 'https://www.facebook.com/',
//       },
//       {
//         icon: 'https://wp-kenya-react.cashplus-ke.avgr.it/wp-content/uploads/2021/12/youtube.svg',
//         url: 'https://www.youtube.com/',
//       },
//       {
//         icon: 'https://wp-kenya-react.cashplus-ke.avgr.it/wp-content/uploads/2021/12/linkedIn.svg',
//         url: 'https://www.linkedin.com/',
//       },
//     ],
//     copyright:
//       '© 2021 ALL RIGHTS RESERVED TO A IS IT CONSULTING SERVICES (PRIVATE) LIMITED. A IS IT CONSULTING SERVICES (PRIVATE) LIMITED IS A COMPANY DULY INCORPORATED AND REGISTERED UNDER THE LAWS OF\n' +
//       'SRI LANKA, WITH COMPANY REGISTRATION NO. PV00215063 GRANTED BY REGISTRAR GENERAL OF COMPANIES AT COLOMBO. A IS IT CONSULTING SERVICES OPERATES THE ONLINE PLATFORM WHICH CONNECTS\n' +
//       'THE BORROWERS WITH THE LENDERS, FACILITATES LOAN PROCESS AND IS NOT ACTING AS A LENDER OR LOAN PROVIDER.',
//     modal_info: [
//       {
//         title: 'Terms and conditions',
//         content: ' ',
//       },
//       {
//         title: 'Privacy Policy',
//         content: ' ',
//       },
//       {
//         title: 'Consent and T&C',
//         content: ' ',
//       },
//     ],
//   },
//   isLoaded: true,
//   isLoading: false,
//   isFailed: false,
//   openModal: null,
// };

export const WPContent: Reducer<IWPContentState> = (state = WPContentState, action) => {
  switch (action.type) {
    case TypesWPContent.GET_WP_CONTENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFailed: false,
      };
    case TypesWPContent.GET_WP_CONTENT_SUCCESS:
      return {
        ...state,
        header: action.data.header || WPContentState.header,
        footer: action.data.footer || WPContentState.footer,
        isLoaded: true,
        isLoading: false,
      };
    case TypesWPContent.GET_WP_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        isFailed: true,
      };
    case TypesWPContent.OPEN_WP_MODAL:
      return {
        ...state,
        openModal: action.data,
      };
    case TypesWPContent.CLOSE_WP_MODAL:
      return {
        ...state,
        openModal: null,
      };
    default:
      return state;
  }
};
